import React from "react";
import { CSSTransition } from "react-transition-group";
const transitionClsList = {
    slideInDown: "transition-slide-down",
    zoomOut: "transition-zoom-out",
};
export default function TransitionListItem(props) {
    /**
     * inType: 列表项进入动画类型
     * exitType: 列表项离开动画类型
     */
    const { inType, exitType, ...rest } = props;

    const getTransitionType = (type) => {
        let result = "";
        const transitionTypeList = Object.keys(transitionClsList);
        if (transitionTypeList.includes(type)) {
            result = transitionClsList[type];
        }
        return result;
    };
    const getClassNames = () => {
        const activeSuffix = "-active";
        const doneSuffix = "-done";
        const result = {
            // appear: 'fade-appear',
            // appearActive: 'fade-appear-active',
            // appearDone: 'fade-appear-done',
            enter: `${getTransitionType(inType)}`,
            enterActive: `${getTransitionType(inType)}${activeSuffix}`,
            enterDone: `${getTransitionType(inType)}${doneSuffix}`,
            exit: `${getTransitionType(exitType)}`,
            exitActive: `${getTransitionType(exitType)}${activeSuffix}`,
            exitDone: `${getTransitionType(exitType)}${doneSuffix}`,
        };
        return result;
    };

    return (
        <CSSTransition classNames={getClassNames()} {...rest}>
            {props.children}
        </CSSTransition>
    );
}
